import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export function setLastGuest(guest: core.IPatron): BaseTockAction {
  return {
    type: AppConstants.UPDATE_LAST_GUEST,
    payload: guest,
  };
}
